<template>
  <tv-page title="TV-秒杀" :loading="loading" :class="_.page">
    <template v-if="!loading">
      <div :class="_.hd">
        <div :class="_.title">
          <img src="./images/秒杀专场.svg" :class="_.logo" />
          <div v-if="seckillDate" :class="_.time">
            秒杀日期：{{ seckillDate }}
          </div>
        </div>
        <x-horizontal-scroll-view
          v-if="seckillDateData.length > 1"
          ref="date"
          :class="_.date"
        >
          <div
            v-for="(item, index) in seckillDateData"
            :key="item.value"
            v-focusable
            :class="[_.item, dateIndex === index && _.active]"
            v-on="dateListeners"
          >
            {{ item.label }}
          </div>
        </x-horizontal-scroll-view>
      </div>

      <div :class="_.bd">
        <div ref="time" :class="_.time">
          <div
            v-for="(item, index) in sessionData"
            :key="item.sessionId"
            v-focusable
            :class="[_.item, sessionIndex === index && _.active]"
            v-on="timeListeners"
          >
            <x-seckill-provider
              :data="item"
              @change="seckillInfo => handleSeckillChange(seckillInfo, index)"
            >
              <template #default="{ seckillInfo }">
                <div :class="_.value">
                  {{
                    seckillInfo.isFull
                      ? '全天'
                      : seckillInfo.formatStart('hh:ii')
                  }}
                </div>
                <div :class="_.label">
                  {{
                    seckillInfo.isPending
                      ? seckillInfo.isToday
                        ? '即将开抢'
                        : '未开始'
                      : seckillInfo.isRunning
                      ? '抢购中'
                      : '已结束'
                  }}
                </div>
              </template>
            </x-seckill-provider>
          </div>
        </div>
        <tv-waterfall
          ref="waterfall"
          :class="_.goods"
          :load="handleLoadData"
          empty-text="暂无商品"
        >
          <template #default="{ data }">
            <x-grid ref="list" :class="_.list" :col-count="2" :gap="40">
              <div
                v-for="item in data"
                :key="item.id"
                v-focusable
                :class="_.item"
                v-on="listListeners.bind(item)"
              >
                <img :src="item.cover" :class="_.cover" />
                <div :class="_.content">
                  <div :class="[_.name, _._ellipsis2]">
                    {{ item.name }}
                  </div>
                  <div :class="_.grow"></div>
                  <div :class="_.price">
                    <div :class="_.current">
                      <div :class="_.unit">¥</div>
                      <div :class="_.value">{{ item.price }}</div>
                    </div>
                    <div :class="_.cost">¥{{ item.cost }}</div>
                    <div :class="_.grow"></div>
                    <template v-if="item.seckillStatus === 'running'">
                      <img
                        v-if="item.seckillSuccess"
                        src="./images/已抢到.png"
                        :class="_.status"
                      />
                      <img
                        v-else-if="item.seckillProgress === 100"
                        src="./images/抢光了.png"
                        :class="_.status"
                      />
                    </template>
                    <img
                      v-else-if="item.seckillStatus === 'pending'"
                      src="./images/未开始.png"
                      :class="_.status"
                    />
                    <img
                      v-else-if="item.seckillStatus === 'ended'"
                      src="./images/已结束.png"
                      :class="_.status"
                    />
                  </div>
                  <div
                    v-if="item.seckillStatus === 'running'"
                    :class="_.progress"
                  >
                    <div :class="_.bar">
                      <div
                        :class="_.completed"
                        :style="{ width: `${item.seckillProgress}%` }"
                      ></div>
                    </div>
                    <div :class="_.label">
                      {{ `已抢${item.seckillProgress}%` }}
                    </div>
                  </div>
                </div>
              </div>
            </x-grid>
          </template>
        </tv-waterfall>
      </div>
    </template>
  </tv-page>
</template>

<script>
  import Vue from 'vue'
  import { anyToDate, formatDate } from 'vtils/date'
  import {
    apiActivityActivityActivitySession,
    apiActivityActivityCommodityList,
    apiActivityActivityIndex,
  } from '@/api'
  import { defaultIndexTo } from 'vtils'
  import { defineTvListeners } from '../utils'
  import { getSeckillInfo, makeUniGoods, prepareData, submit } from '@/utils'
  import { navigateTo } from '@/router'

  export default Vue.extend({
    data() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const ctx = this
      return {
        loading: false,

        id: '',
        dateIndex: '',
        sessionIndex: 0,
        onlyAvailable: false,

        seckillDateData: [],
        seckillDate: '',
        seckillData: {},
        sessionData: [],

        isEnded: false,

        // 跳到日期
        goToDate: index => {
          ctx.$tv.goTo(ctx.$refs.date, index)
        },

        // 跳到时间
        goToTime: index => {
          ctx.$tv.goTo(ctx.$refs.time, index)
        },

        // 跳到列表
        goToList: index => {
          ctx.$tv.goTo(ctx.$refs.list, index)
        },

        // 日期监听器
        dateListeners: defineTvListeners(({ type, index, isLast }) => {
          switch (type) {
            case 'focus':
              ctx.$tv.setScrollEl(ctx.$refs.date)
              this.dateIndex = index
              break
            case 'down':
              ctx.$tv.resetScrollEl()
              this.goToTime(this.sessionIndex)
              break
            case 'right':
              if (isLast) {
                this.goToDate(-1)
              }
              break
            default:
              break
          }
        }),

        // 时间监听器
        timeListeners: defineTvListeners(({ type, index, isFirst, isLast }) => {
          switch (type) {
            case 'focus':
              this.sessionIndex = index
              break
            case 'up':
              if (isFirst) {
                this.goToDate(this.dateIndex)
              }
              break
            case 'down':
              if (isLast) {
                this.goToList(0)
              }
              break
            case 'left':
              this.goToDate(this.dateIndex)
              break
            case 'right':
              this.goToList(0)
              break
            default:
              break
          }
        }),

        // 列表监听器
        listListeners: defineTvListeners(
          ({ type, index, isFirst, isLast, item }) => {
            switch (type) {
              case 'up':
                if (index < 2) {
                  this.goToDate(this.dateIndex)
                }
                break
              case 'left':
                if (isFirst) {
                  this.goToTime(this.sessionIndex)
                } else {
                  this.goToList(index - 1)
                }
                break
              case 'right':
                if (!isLast) {
                  this.goToList(index + 1)
                } else {
                  this.goToList(-1)
                }
                break
              case 'click':
                navigateTo('TvGoodsIndex', {
                  id: item.id,
                })
                break
              default:
                break
            }
          },
        ),
      }
    },

    watch: {
      onlyAvailable() {
        // onlyAvailable 已作为列表的 key，它会重新渲染刷新，无需手动刷新，否则会导致请求多次
        // this.$reloadWaterfall('list')
      },
      sessionIndex() {
        this.$reloadWaterfall('waterfall')
      },
      async dateIndex() {
        await this.getSessions()
        this.$reloadWaterfall('waterfall')
      },
    },

    created() {
      this.prepareData()
    },

    methods: {
      formatDate(date, noYear) {
        return formatDate(anyToDate(date), noYear ? 'm月d日' : 'yyyy年m月d日')
      },

      async prepareData() {
        this.loading = true
        const { seckillData } = await prepareData({
          seckillData: apiActivityActivityIndex(),
        })
        this.seckillData = seckillData
        if (!seckillData.hasActivity) {
          this.loading = false
          return
        }
        this.seckillDateData = seckillData.activityDates.map(item => ({
          label: this.formatDate(item, true),
          value: item,
        }))
        this.seckillDate = [
          this.formatDate(seckillData.activityDates[0]),
          seckillData.activityDates.length > 1 &&
            this.formatDate(
              seckillData.activityDates[seckillData.activityDates.length - 1],
              true,
            ),
        ]
          .filter(Boolean)
          .join('-')
        this.id = seckillData.activityId
        this.dateIndex = defaultIndexTo(
          this.seckillDateData.findIndex(
            item => item.value === seckillData.matchDate,
          ),
          0,
        )
        this.loading = false
      },

      async getSessions() {
        await submit(async $ => {
          $.start()
          const sessions = await apiActivityActivityActivitySession({
            date: this.seckillDateData[this.dateIndex].value,
          })
          this.sessionData = sessions.map(session => {
            return {
              ...session,
              ...getSeckillInfo(session),
            }
          })
          // 首先进行中的场次，其次即将开始的场次，最后第一场
          this.sessionIndex = defaultIndexTo(
            this.sessionData.findIndex(item => item.isRunning),
            defaultIndexTo(
              this.sessionData.findIndex(item => item.isPending),
              0,
            ),
          )
        })
      },

      handleSeckillChange(seckillInfo, index) {
        // 当前选中的场次状态变化时刷新数据
        if (
          this.sessionIndex === index &&
          seckillInfo.prevStatus != null &&
          seckillInfo.prevStatus !== seckillInfo.status
        ) {
          this.$reloadWaterfall('waterfall')
        }
      },

      async handleLoadData({ pageNumber }) {
        try {
          const data = await apiActivityActivityCommodityList(
            {
              activityId: this.id,
              pageIndex: pageNumber,
              pageSize: 10,
              sessionId: this.sessionData[this.sessionIndex].sessionId,
              type: this.onlyAvailable ? 2 : 1,
            },
            {
              noErrorToast: true,
            },
          ).then(res => {
            res.list = res.list.map(item =>
              makeUniGoods({
                ...item,
                status: getSeckillInfo(this.sessionData[this.sessionIndex])
                  .status,
              }),
            )
            return res
          })
          return data
        } catch {
          this.isEnded = true
        }
      },
    },
  })
</script>

<style lang="scss" module>
  .page {
    background-color: #1f2733;
  }

  .hd {
    width: 100%;
    background-image: url('./images/秒杀头部.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    padding: 0 80px;
    box-sizing: border-box;

    .title {
      display: flex;
      align-items: flex-end;
      padding: 60px 0 47px 0;

      .logo {
        width: 255px;
        height: 62.83px;
      }

      .time {
        margin-left: 20px;
        font-size: 30px;
        color: rgba(#ffffff, 0.6);
      }
    }

    .date {
      // 解决 y 轴溢出问题
      // https://stackoverflow.com/a/39554003
      padding: 20px;
      margin: -20px;
      margin-bottom: 0;

      .item {
        display: inline-flex;
        align-items: center;
        height: 70px;
        border-radius: 100px;
        --border-radius: 100px;
        padding: 0 40px;
        font-size: 40px;
        color: rgba(white, 0.6);

        &.active {
          background: rgba(255, 255, 255, 0.3);
          color: white;
        }

        &[focused] {
          background: #ffffff;
          color: #e0251b;
        }
      }
    }
  }

  .bd {
    padding: 40px 80px;
    display: flex;
    align-items: flex-start;

    .time {
      flex-shrink: 0;

      .item {
        width: 260px;
        height: 120px;
        border-radius: 8px;
        --border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        .value {
          font-size: 40px;
          color: rgba(#ffffff, 0.6);
          line-height: 58px;
        }

        .label {
          margin-top: 2px;
          font-size: 28px;
          color: rgba(#ffffff, 0.4);
          line-height: 40px;
        }

        &.active {
          background: rgba(255, 255, 255, 0.1);

          .value {
            color: white;
          }

          .label {
            color: white;
          }
        }

        &[focused] {
          background: #e0251b;
        }
      }
    }

    .goods {
      flex-grow: 1;

      .list {
        margin-left: 40px;
        flex-grow: 1;

        .item {
          display: flex;
          align-items: stretch;
          background: #ffffff;
          padding: 20px;
          border-radius: 12px;
          --border-radius: 12px;

          .cover {
            flex-shrink: 0;
            width: 230px;
            height: 230px;
            border-radius: 12px;
            object-fit: cover;
          }

          .content {
            margin-left: 20px;
            flex-grow: 1;
            font-size: 0;
            display: flex;
            flex-direction: column;

            .name {
              font-size: 32px;
              font-weight: 500;
              color: #333333;
              line-height: 46px;
            }

            .grow {
              flex-grow: 1;
            }

            .price {
              display: flex;
              align-items: baseline;

              .current {
                display: flex;
                align-items: baseline;

                .unit {
                  font-size: 26px;
                  color: #ff3b30;
                }

                .value {
                  font-size: 44px;
                  font-weight: 500;
                  color: #ff3b30;
                }
              }

              .cost {
                margin-left: 10px;
                font-size: 26px;
                color: #999999;
                text-decoration: line-through;
              }

              .status {
                width: 100px;
                height: 100px;
              }
            }

            .progress {
              display: flex;
              align-items: center;

              .bar {
                position: relative;
                flex-grow: 1;
                height: 8px;
                background: rgba(255, 59, 48, 0.4);
                border-radius: 8px;

                .completed {
                  position: absolute;
                  left: 0;
                  top: 0;
                  bottom: 0;
                  width: 20%;
                  background: #ff3b30;
                  border-radius: 8px;
                }
              }

              .label {
                flex-shrink: 0;
                width: 120px;
                text-align: right;
                font-size: 24px;
                color: #999999;
              }
            }
          }
        }
      }
    }
  }
</style>
